import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import FeaturedGameImage from '../components/FeaturedGameImage';
import JoinUsSection from '../components/JoinUsSection';
import { visibleGames } from '../data/games';

function HomePage() {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveSlide((current) => (current + 1) % visibleGames.length);
    }, 7000);

    return () => window.clearInterval(timer);
  }, []);

  const featured = visibleGames[activeSlide];

  return (
    <main className="kg-main">
      <section className="kg-spotlight" aria-label="Featured game spotlight">
        <div className="kg-spotlight-inner">
          <div className="kg-spotlight-copy">
            <p className="kg-spotlight-badge">{featured.badge}</p>
            <h1 className="kg-spotlight-title">{featured.title}</h1>
            <p className="kg-spotlight-desc">{featured.description}</p>
            <Link to={`/games/${featured.slug}`} className="kg-btn kg-btn-primary">
              Learn More
            </Link>
            <div className="kg-spotlight-dots" role="tablist" aria-label="Featured games">
              {visibleGames.map((game, index) => (
                <button
                  key={game.id}
                  type="button"
                  role="tab"
                  aria-selected={index === activeSlide}
                  aria-label={`Show ${game.title}`}
                  className={`kg-spotlight-dot${index === activeSlide ? ' is-active' : ''}`}
                  onClick={() => setActiveSlide(index)}
                />
              ))}
            </div>
          </div>

          <Link to={`/games/${featured.slug}`} className="kg-spotlight-art kg-sketch-frame">
            <img
              src={featured.image}
              alt={featured.title}
              className="kg-spotlight-art-img"
              loading="lazy"
              decoding="async"
            />
          </Link>
        </div>
      </section>

      <section id="games" className="kg-section kg-featured-games">
        <div className="kg-featured-games-inner">
          <h2 className="kg-featured-heading">Featured Games</h2>
          <div className="kg-games-grid">
            {visibleGames.map((game, index) => (
              <Link
                key={game.id}
                to={`/games/${game.slug}`}
                className={`kg-game-card kg-game-card-${index + 1}`}
              >
                <span className="kg-game-card-frame">
                  <FeaturedGameImage game={game} />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <JoinUsSection />
    </main>
  );
}

export default HomePage;
